import {
	CognitoUser,
	CognitoUserPool,
	AuthenticationDetails,
	CognitoUserAttribute,
	CognitoIdToken,
	CognitoAccessToken,
	CognitoRefreshToken,
	CognitoUserSession
} from 'amazon-cognito-identity-js';
import renderError from '../utils/renderErrorMessage';
import formatCognitoUserData from '../utils/formatCognitoUserData';
import formatCognitoAttributesData from '../utils/formatCognitoAttributesData';
import isDuplicateEmailError from "../helpers/isDuplicateEmailError";

const getUserPool = () => {
	const data = localStorage.ffaRedirectUri && localStorage.ffaRedirectUri.includes('learning', 'learn', 'training')
		? { UserPoolId: CognitoUserPoolId, ClientId: CognitoClientIdEtrain }
		: { UserPoolId: CognitoUserPoolId, ClientId: CognitoClientIdPlayfootball};

	return (new CognitoUserPool(data));
}

export default {
	refreshSession: ({refreshToken}) => {
		console.info("COGNITO_refreshSession");
		console.time("COGNITO_refreshSession");

		const cognitoUser = (getUserPool()).getCurrentUser();
		const RefreshToken = new CognitoRefreshToken({
			RefreshToken: refreshToken
		});

		return new Promise((resolve, reject) => {
			if (cognitoUser === null) {
				reject();
				return;
			}

			cognitoUser.refreshSession(RefreshToken, function (err, session) {
				if (err) {
					// console.log('cognitoUser.refreshSession error:', err);
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				resolve({
					accessToken: session.getAccessToken().getJwtToken(),
					idToken: session.idToken.jwtToken,
					refreshToken: session.getRefreshToken().token,
				});
			});
		});
	},
	retrieveCurrentUser: () => {
		console.info("COGNITO_retrieveCurrentUser");
		console.time("COGNITO_retrieveCurrentUser");

		let cognitoUser = (getUserPool()).getCurrentUser();

		return new Promise(function (resolve, reject) {
			if (cognitoUser === null) {
				reject();
				return;
			}

			cognitoUser.getSession(function (sessionErrors, session) {
				if (sessionErrors || !session.isValid()) {
					reject();
					return;
				}

				resolve(formatCognitoUserData(session));
			});
		});
	},
	retrieveUserAttributes: () => {
		console.info("COGNITO_retrieveUserAttributes");
		console.time("COGNITO_retrieveUserAttributes");

		const cognitoUser = (getUserPool()).getCurrentUser();

		return new Promise(function (resolve, reject) {
			if (cognitoUser === null) {
				reject();
				return;
			}

			cognitoUser.getSession(function (sessionErrors, session) {
				if (sessionErrors || !session.isValid()) {
					reject();
					return;
				}

				cognitoUser.getUserAttributes(function (attributesError, attributesArray) {
					if (attributesError) {
						// console.log('attributesError: ', attributesError);
						reject();
						return;
					}

					const attributesObject = formatCognitoAttributesData(attributesArray);
					resolve(attributesObject);
				});
			});
		});
	},
	logout: () => {
		console.info("COGNITO_logout");
		console.time("COGNITO_logout");

		// https://ffa-id-dev.auth.ap-southeast-2.amazoncognito.com/logout?redirect_uri=https://keeper.footballhub.com/idpresponse.html&response_type=token&client_id=5dmldlltlhj7ho96dg9trtpd2s&scope=openid%20aws.cognito.signin.user.admin
		let cognitoUser = (getUserPool()).getCurrentUser();

		return new Promise((resolve) => {
			if (cognitoUser !== null) {
				cognitoUser.signOut();
			}
			resolve();
		});
	},
	login: ({email, password}) => {
		console.info("COGNITO_login");
		console.time("COGNITO_login");

		let username = email;

		let cognitoUser = new CognitoUser({
			Username: username,
			Pool: (getUserPool())
		});

		let authenticationDetails = new AuthenticationDetails({
			Username: username,
			Password: password
		});

		return new Promise((resolve, reject) => {
			cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: function (result) {
					console.log('login.result', result)
					resolve(formatCognitoUserData(result));
				},
				onFailure: function (err) {
					console.log('login.err', err)
					reject({global: renderError(err)});
				}
			});

		});
	},
	register: userData => {
		console.info("COGNITO_register");
		console.time("COGNITO_register");

		userData.email = userData.email.toLowerCase();

		let attributeList = [];
		attributeList.push(new CognitoUserAttribute({
			Name: 'given_name',
			Value: userData.firstName
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'family_name',
			Value: userData.lastName
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'email',
			Value: userData.email.toLowerCase()
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'birthdate',
			Value: userData.dateOfBirth
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'custom:postcode',
			Value: userData.postcode
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'custom:marketing_optin',
			Value: userData.emailOpt ? 'true' : 'false'
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'custom:is_first_login',
			Value: userData.isFirstLogin ? 'true' : 'false'
		}));


		console.time("TIME_calling_userPool.signUp");
		return new Promise((resolve, reject) => {
			(getUserPool()).signUp(userData.email.toLowerCase(), userData.password, attributeList, null, function(err, result) {
				console.timeEnd("TIME_calling_userPool.signUp");
				console.log('Error!', err)
				if (err) {
					if (isDuplicateEmailError(err.message)) {
						reject({login: renderError(err)});
					} else {
						reject({global: renderError(err)});
					}
					return;
				}

				resolve(userData);

			});

		});
	},
	verify: ({email, code}) => {
		console.info("COGNITO_verify");
		console.time("COGNITO_verify");

		let cognitoUser = new CognitoUser({
			Username: email.toLowerCase(),
			Pool: (getUserPool())
		});

		console.time("TIME_calling_cognitoUser.confirmRegistration");

		/*return new Promise((resolve, reject) => {
			cognitoUser.confirmRegistration(code, true, function (err, result) {
				console.timeEnd("TIME_calling_cognitoUser.confirmRegistration");
				if (err) {
					reject({ global: renderError( err ) });
					return;
				}
				resolve();
			});
		});*/

		const promiseTimeout = new Promise((res) => {
			setTimeout(res, 500, 'timeout')
		});

		const promiseFunction = new Promise((resolve, reject) => {
			cognitoUser.confirmRegistration(code, true, function (err, result) {
				console.timeEnd("TIME_calling_cognitoUser.confirmRegistration");
				if (err) {
					reject({global: renderError(err)});
					return;
				}
				resolve();
			});
		});

		return Promise.all([promiseTimeout, promiseFunction]);
	},
	updateCrmId: crmId => {
		let cognitoUser = (getUserPool()).getCurrentUser();

		let attributeList = [];
		attributeList.push(new CognitoUserAttribute({
			Name: 'custom:crmid',
			Value: crmId
		}));

		return new Promise((resolve, reject) => {
			cognitoUser.getSession((err, session) => {
				if (err) {
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				if (session.isValid()) {
					cognitoUser.updateAttributes(attributeList, function(err, result) {
						if (err) {
							reject({global: renderError(err)});
							return;
						}

						resolve();
					});
				}
			});
		});
	},
	updateUserDetails: userDetails => {
		console.info("COGNITO_updateUserDetails");
		console.time("COGNITO_updateUserDetails");

		let cognitoUser = (getUserPool()).getCurrentUser();

		console.log('userPool', (getUserPool()))
		console.log('cognitoUser.getCurrentUser', cognitoUser)

		let attributeList = [];
		attributeList.push(new CognitoUserAttribute({
			Name: 'given_name',
			Value: userDetails.given_name
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'family_name',
			Value: userDetails.family_name
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'birthdate',
			Value: userDetails.birthdate
		}));
		attributeList.push(new CognitoUserAttribute({
			Name: 'custom:is_first_login',
			Value: userDetails.isFirstLogin
		}));

		return new Promise((resolve, reject) => {
			console.log('cognitoUser inside promise', cognitoUser)
			cognitoUser.getSession((err, session) => {
				console.log('Error! cognitoUser.getSession', err, session)
				console.time('Error! cognitoUser.getSession', err, session)

				if (err) {
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				if (session.isValid()) {
					cognitoUser.updateAttributes(attributeList, function (err, result) {
						console.log('Error! cognitoUser.updateAttributes', err)
						console.time('Error! cognitoUser.updateAttributes', err)

						if (err) {
							reject({global: renderError(err)});
							return;
						}

						resolve();
					});
				}
			});
		});
	},
	changePassword: ({oldPassword, newPassword}) => {
		console.info("COGNITO_changePassword");
		console.time("COGNITO_changePassword");

		let cognitoUser = (getUserPool()).getCurrentUser();

		return new Promise((resolve, reject) => {
			cognitoUser.getSession((err, session) => {
				if (err) {
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				if (session.isValid()) {
					cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
						if (err) {
							reject({global: renderError(err)});
							return;
						}

						resolve();
					});
				}
			});
		});
	},
	resendCode: ({email}) => {
		console.info("COGNITO_resendCode");
		console.time("COGNITO_resendCode");

		let cognitoUser = new CognitoUser({
			Username: email.toLowerCase(),
			Pool: (getUserPool())
		});

		return new Promise((resolve, reject) => {
			cognitoUser.resendConfirmationCode(function (err, result) {
				if (err) {
					reject({global: renderError(err)});
					return;
				}

				resolve();
			});
		});
	},
	resetPassword: ({email}) => {
		console.info("COGNITO_resetPassword");
		console.time("COGNITO_resetPassword");

		let cognitoUser = new CognitoUser({
			Username: email,
			Pool: (getUserPool())
		});

		return new Promise((resolve, reject) => {
			cognitoUser.forgotPassword({
				onSuccess: function (result) {
					resolve();
				},
				onFailure: function (err) {
					reject({global: renderError(err)});
				}
			});
		});

	},
	createPassword: ({email, code, newPassword}) => {
		console.info("COGNITO_createPassword");
		console.time("COGNITO_createPassword");

		let cognitoUser = new CognitoUser({
			Username: email,
			Pool: (getUserPool())
		});

		return new Promise((resolve, reject) => {
			cognitoUser.confirmPassword(code, newPassword, {
				onSuccess: function (result) {
					resolve();
				},
				onFailure: function (err) {
					reject({global: renderError(err)});
				}
			})
		});
	},
	changeEmail: (email) => {
		console.info("COGNITO_changeEmail");
		console.time("COGNITO_changeEmail");

		let cognitoUser = (getUserPool()).getCurrentUser();

		return new Promise((resolve, reject) => {
			cognitoUser.getSession((err, session) => {
				if (err) {
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				if (session.isValid()) {
					let attributeList = [];

					attributeList.push(new CognitoUserAttribute({
						Name: 'email',
						Value: email.newEmail.toLowerCase()
					}));

					cognitoUser.updateAttributes(attributeList, function (err, result) {
						if (err) {
							reject({global: renderError(err)});
							return;
						}
						resolve();
					});
				}
			});
		});
	},
	verifyChangedEmail: (emailData) => {
		console.info("COGNITO_verifyChangedEmail");
		console.time("COGNITO_verifyChangedEmail");

		let cognitoUser = (getUserPool()).getCurrentUser();
		const verificationCode = emailData.code;

		return new Promise((resolve, reject) => {
			cognitoUser.getSession((err, session) => {
				if (err) {
					reject({global: 'Sorry, Something Went Wrong: Please try again later.'});
					return;
				}

				if (session.isValid()) {
					cognitoUser.verifyAttribute('email', verificationCode, {
						onSuccess: function (result) {
							resolve();
						},
						onFailure: function (err) {
							if (err) {
								reject({global: renderError(err)});
								return;
							}
						}
					});
				}
			});
		});
	},
	createUserSession: (tokens) => {
		console.info("COGNITO_createUserSession");
		console.time("COGNITO_createUserSession");

		const AccessToken = new CognitoAccessToken({AccessToken: tokens.access_token});
		const IdToken = new CognitoIdToken({IdToken: tokens.id_token});
		const RefreshToken = new CognitoRefreshToken();
		const cachedSession = new CognitoUserSession({
			IdToken: IdToken,
			AccessToken: AccessToken,
			RefreshToken: RefreshToken,
			ClockDrift: undefined
		});

		let cognitoUser = new CognitoUser({
			Username: IdToken.payload["cognito:username"],
			Pool: (getUserPool())
		});

		return new Promise((resolve, reject) => {
			cognitoUser.setSignInUserSession(cachedSession);
			resolve();
		});
	}
}